var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { ContainerFull, MultiQuoteHeading, } from "../../../components/Styles/Styles";
import { PHASE } from "../../../routeConfig";
import Timer from "../../../components/Timer";
import { WaitingIcon } from "../../../components/Icons/Icons";
import useAccountReferenceId from "../../../services/savvy/useAccountReferenceId";
import useAppSelector from "../../../hooks/useAppSelector";
import { useDidMount } from "rooks";
import { useHistory } from "react-router-dom";
import { useLazyGetPoliciesQuery } from "../../../services/connect";
import { useUpdateAccountInfoMutation } from "../../../services/savvy";
export default function BasePoliciesLoadingRoute(_a) {
    var _this = this;
    var connectionId = _a.connectionId, temporaryAccessKey = _a.temporaryAccessKey, onPoliciesLoaded = _a.onPoliciesLoaded;
    var getAccountReferenceId = useAccountReferenceId().getAccountReferenceId;
    var getPolicies = useLazyGetPoliciesQuery()[0];
    var updateAccountInfo = useUpdateAccountInfoMutation()[0];
    var push = useHistory().push;
    var jornayaLeadId = useAppSelector(function (_a) {
        var jornayaLeadId = _a.applicant.jornayaLeadId;
        return {
            jornayaLeadId: jornayaLeadId.savvy,
        };
    }).jornayaLeadId;
    useDidMount(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var accountReferenceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAccountReferenceId({
                            accountConnectionId: connectionId,
                        }).unwrap()];
                    case 1:
                        accountReferenceId = _a.sent();
                        return [4 /*yield*/, updateAccountInfo({
                                accountReferenceId: accountReferenceId,
                                jornayaLeadId: jornayaLeadId,
                            })];
                    case 2:
                        _a.sent();
                        getPolicies({ connectionId: connectionId, temporaryAccessKey: temporaryAccessKey })
                            .unwrap()
                            .then(onPoliciesLoaded)
                            .catch(function () {
                            push(PHASE.MID_FUNNEL_ADS);
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
    });
    if (!connectionId) {
        throw new Error("Error while loading policy summaries: Connection ID is missing");
    }
    if (!temporaryAccessKey) {
        throw new Error("Error while loading policy summaries: Temporary Access Key is missing");
    }
    return (React.createElement(ContainerFull, { centerVertically: true },
        React.createElement(WaitingIcon, null),
        React.createElement("div", { className: "max-w-xs md:max-w-sm" },
            React.createElement(MultiQuoteHeading, { style: { margin: "20px 32px 0px" } }, "Checking your policy..."),
            React.createElement("div", { className: "mx-8 mt-1 text-center text-lg" }, "We are loading the data you have on file with your current insurer so you can skip the forms and get the best quote."),
            React.createElement("div", { className: "mx-8 mt-10 text-center text-[15px] italic" },
                "This process takes ",
                React.createElement("span", { className: "font-bold" }, "20-30 seconds"),
                ", but some insurers need 2-3 minutes. Thank you for your patience!")),
        React.createElement("div", { className: "mt-[45px] text-center text-[15px] italic" }, "You have waited for"),
        React.createElement(Timer, null)));
}
